import { getLastAttributionId } from "../Attribution";

const LAST_VIEWED_CLIP_KEY = "lastViewedClip";
const LAST_VIEWED_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const OBJECT_ID_PATTERN = /^[a-f0-9]{24}$/i;

export const recordClipView = (shareId: string): void => {
  try {
    localStorage.setItem(
      LAST_VIEWED_CLIP_KEY,
      JSON.stringify({ shareId, at: Date.now() }),
    );
  } catch (e) {}
};

export const getLastViewedShareId = (): string | null => {
  try {
    const raw = localStorage.getItem(LAST_VIEWED_CLIP_KEY);
    if (!raw) return null;
    const { shareId, at } = JSON.parse(raw);
    if (!shareId || Date.now() - at > LAST_VIEWED_TTL_MS) return null;
    return shareId;
  } catch (e) {
    return null;
  }
};

export const clearLastViewedClip = (): void => {
  try {
    localStorage.removeItem(LAST_VIEWED_CLIP_KEY);
  } catch (e) {}
};

// Share links write ref into attribution storage as a user id, but logged-out
// sharers produce ref="anonymous" — only a real ObjectId is a creditable referrer.
export const getReferralSignupParams = (): {
  ref?: string;
  lastViewedShareId?: string;
} => {
  const params: { ref?: string; lastViewedShareId?: string } = {};
  const ref = getLastAttributionId();
  if (ref && OBJECT_ID_PATTERN.test(ref)) params.ref = ref;
  const lastViewedShareId = getLastViewedShareId();
  if (lastViewedShareId) params.lastViewedShareId = lastViewedShareId;
  return params;
};
